'use client';

import { SkeletonBar, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { useState } from 'react';

import type { StoreData } from '@libs/common-types';

import type { InventoryStatusTone } from '../lib/inventory-status';
import './bopis-store-status.scss';

export type BopisStoreStatusProps = Readonly<{
    isLoading: boolean;
    label: string;
    tone?: InventoryStatusTone;
    storeDetails?: StoreData['storeDetails'] | null;
}>;

export function BopisStoreStatus({ isLoading, label, tone, storeDetails }: BopisStoreStatusProps) {
    const [showTooltip, setShowTooltip] = useState(false);
    const storeName = storeDetails?.name;

    if (isLoading) {
        return <SkeletonBar className="delivery-details__status-skeleton" data-testid="inventory-status-loading" />;
    }

    if (!storeName) {
        return (
            <TextPassage size="lg" data-testid="inventory-status">
                {label}
            </TextPassage>
        );
    }

    return (
        <div className="bopis-store-status-content">
            <TextPassage
                size="lg"
                data-testid="inventory-status"
                className={cn({
                    'sparky-u-color-utility-success': tone === 'success',
                    'sparky-u-color-utility-error': tone === 'error',
                })}
            >
                {label}
                <span className="delivery-details__store"> at </span>
                <button
                    className="sparky-u-theme-typography-body-lg-bold delivery-details__store button-reset"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    type="button"
                >
                    {storeName}
                    <div
                        className="sparky-c-tooltip__content"
                        style={{
                            display: showTooltip ? 'block' : 'none',
                        }}
                    >
                        {storeDetails?.streetLine1}
                        {storeDetails?.streetLine2 && (
                            <>
                                <br />
                                {storeDetails.streetLine2}
                            </>
                        )}
                        <br />
                        {storeDetails?.city}, {storeDetails?.stateProvinceAbbreviation} {storeDetails?.zipPostalCode}
                    </div>
                </button>
            </TextPassage>
        </div>
    );
}
